(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AuthControllerV2', ["$scope", "http", "oauthPopup", "path", "avananUserDao", "routeHelper", "$routeParams", "$location", "configDao", "trialExpiredModal", "feature", "autologinHelper", "recaptcha", "$q", "jira", "$rootScope", function ($scope, http, oauthPopup, path, avananUserDao, routeHelper, $routeParams, $location, configDao, trialExpiredModal, feature, autologinHelper, recaptcha, $q, jira, $rootScope) {
        $scope.path = path;
        var root = path('gui-v2').ctrl('auth-v2');
        $scope.error = {};
        $scope.page = $routeParams.page;
        $scope.checkpointTheme = feature.checkpointTheme;
        jira.hide();
        $scope.logoSwitch = function () {
            var logoClass = {};
            if (feature.lastlineTheme) {
                logoClass['lastline-logo'] = true;
                $scope.showPoweredBy = true;
            } else if (feature.sonicwallTheme) {
                logoClass['sonicwall-logo'] = true;
                $scope.showPoweredBy = true;
            } else {
                logoClass['avanan-logo'] = true;
            }
            return logoClass;
        };
        if ($scope.page == 'password-reset') {
            var qs = $location.search();
            $scope.token = qs.token;
            if (_($scope.token).isUndefined()) {
                changePage('login');
            }
        }
        $scope.loginModel = {
            email: '',
            password: '',
            repeatPassword: ''
        };
        $scope.loginButtons = [{
                'class': 'google-button',
                image: root.imgRel('google.svg'),
                text: 'Login with Google',
                execute: function () {
                    oauthPopup('/auth/login_google');
                }
            }];
        if (feature.checkpointTheme) {
            $scope.loginButtons.push({
                'class': 'password-button',
                icon: 'fa-lock',
                text: 'Login with password',
                execute: function () {
                    changePage('password-login');
                }
            });
        }
        if (feature.samlAuth) {
            $scope.loginButtons.push({
                'class': 'saml-button',
                icon: 'fa-lock',
                text: 'Login with SAML',
                execute: function () {
                    oauthPopup('/auth/saml/login');
                }
            });
        }
        $scope.loginButtonWorking = true;
        recaptcha.init().then(function (enabled) {
            $scope.loginButtonWorking = false;
            $scope.showRecaptcha = enabled;
        });
        $scope.login = function () {
            if ($scope.loginButtonWorking) {
                return;
            }
            $scope.error = {};
            if (!$scope.loginModel.email) {
                $scope.error.email = 'Please enter valid account email address and password';
                return;
            }
            if (!$scope.loginModel.password) {
                $scope.error.password = 'Password can not be empty';
                return;
            }
            $scope.loginButtonWorking = true;
            var p = $q.when();
            if ($scope.showRecaptcha) {
                p = p.then(function () {
                    return recaptcha.execute();
                }).then(function (token) {
                    $scope.recaptchaToken = token;
                });
            }
            p.then(function () {
                return avananUserDao.login($scope.loginModel.email, $scope.loginModel.password, $scope.recaptchaToken).then(function (response) {
                    if (response.data && response.data.password_expired) {
                        $scope.loginButtonWorking = false;
                        return routeHelper.redirectTo('password-change');
                    }
                    return avananUserDao.current().then(function (response) {
                        $scope.loginButtonWorking = false;
                        if (response.data.hidden) {
                            return routeHelper.restoreRoute();
                        }
                        return configDao.getTrialExpirationDays().then(function (res) {
                            var trialExpirationDays = res.pocExpiresInDays;
                            if (res.deployment_mode === 'demo') {
                                trialExpirationDays = res.demoExpiresInDays;
                            }
                            if (trialExpirationDays < 0) {
                                avananUserDao.logout();
                                return trialExpiredModal.show().then(function () {
                                    $rootScope.$broadcast('$logout', { reason: 'trial expired' });
                                });
                            }
                            return routeHelper.restoreRoute();
                        });
                    }, function (error) {
                        $scope.loginButtonWorking = false;
                    });
                }, function (error) {
                    $scope.loginButtonWorking = false;
                    $scope.error.email = error.data.message;
                    $scope.error.password = error.data.message;
                });
            });
        };
        $scope.restore = function () {
            $scope.error = {};
            if (!$scope.loginModel.email) {
                $scope.error.email = 'Please enter valid account email address';
                return;
            }
            var p = $q.when();
            if ($scope.showRecaptcha) {
                p = p.then(function () {
                    return recaptcha.execute();
                }).then(function (token) {
                    $scope.recaptchaToken = token;
                });
            }
            p.then(function () {
                avananUserDao.forgot($scope.loginModel.email, $scope.recaptchaToken).then(function () {
                    changePage('email-sent');
                }, function (error) {
                    $scope.error.email = error.data.message;
                });
            });
        };
        $scope.back = function () {
            if ($scope.page === 'password-restore' && $scope.checkpointTheme) {
                changePage('password-login');
            } else {
                changePage('login');
            }
        };
        $scope.restorePassword = function (event) {
            event.preventDefault();
            changePage('password-restore');
        };
        $scope.changePassword = function () {
            $scope.error = {};
            if (!$scope.loginModel.password) {
                $scope.error.password = 'Password should not be empty';
                return;
            }
            if ($scope.loginModel.repeatPassword != $scope.loginModel.password) {
                $scope.error.repeatPassword = 'Passwords do not match, please retry';
                return;
            }
            avananUserDao.reset($scope.token, $scope.loginModel.password).then(function () {
                changePage('password-login');
            }, function (error) {
                $scope.error.password = error.data.message.replace(/\n/g, '<br />');
            });
        };
        function changePage(newPage) {
            $scope.error = {};
            routeHelper.redirectTo('auth', { page: newPage }, {
                replace: true,
                reload: false,
                saveQueryString: true
            });
            $scope.page = newPage;
        }
        $scope.poweredByLogo = path('gui-v2').directive('side-menu-v2').imgRel('logo-dark-grey.svg');
        $scope.getTitle = function () {
            var titleObject = {
                'login': '',
                'password-login': '',
                'password-restore': 'Forgot Password',
                'email-sent': 'Forgot Password',
                'password-reset': 'Password Reset'
            };
            if (feature.checkpointTheme) {
                titleObject.login = 'Login';
                titleObject['password-login'] = 'Login';
            } else if (feature.lastlineTheme) {
                titleObject.login = 'Login to Lastline Cloud Security';
                titleObject['password-login'] = 'Login to Lastline Cloud Security';
            } else if (feature.sonicwallTheme) {
                titleObject.login = 'Login to SonicWall Cloud Application Security';
                titleObject['password-login'] = 'Login to SonicWall Cloud Application Security';
            } else {
                titleObject.login = 'Login to Avanan';
                titleObject['password-login'] = 'Login to Avanan';
            }
            return titleObject[$scope.page];
        };
        $scope.loginHeader = function () {
            if (feature.lastlineTheme) {
                return { 'lastline-header': true };
            } else if (feature.sonicwallTheme) {
                return { 'sonicwall-header': true };
            }
            return;
        };
        if (autologinHelper.enabled()) {
            $scope.autoLoggingIn = true;
            avananUserDao.autologin(autologinHelper.first_time_token(), autologinHelper.serialNumber()).then(function () {
                autologinHelper.isLoggedIn(true);
                window.successLogin();
            }, function (error) {
                autologinHelper.isLoggedIn(false);
                $scope.autoLoggingIn = false;
            });
        }
    }]);
}());